import { useEffect } from "react";
import { createPortal } from "react-dom";
import cn from "classnames";
import { CloseIcon } from "@/shared/assets/icons";

interface ModalWrapperProps {
  onClose: () => void;
  children: React.ReactNode;
  width?: string;
}

export default function ModalWrapper({ onClose, children, width = "w-md" }: ModalWrapperProps) {
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key !== "Escape") return;
      const hasHigherOverlay = document.querySelector(".z-\\[10200\\]");
      if (hasHigherOverlay) return;
      onClose();
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return createPortal(
    <div
      className="fixed top-0 left-0 w-screen h-screen surface-backdrop blur-level-1 flex justify-center items-center z-[10001]"
      onClick={onClose}>
      <div
        className={cn(
          `
            background-static-white radius-lg prompt-box-shadow
            relative flex flex-col
            ${width} max-h-[80vh]
            p-8 gap-6
          `,
        )}
        onClick={(e) => e.stopPropagation()}>
        <button
          className="btn btn-tertiary btn-icon absolute! top-8 right-8 z-10 w-8! h-8! p-0! flex items-center justify-center radius-xs content-base-secondary! cursor-pointer"
          onClick={onClose}>
          <CloseIcon />
        </button>
        {children}
      </div>
    </div>,
    document.body,
  );
}
